import { Box, Typography } from "@mui/material";
import AutoAwesomeRoundedIcon from "@mui/icons-material/AutoAwesomeRounded";
import RecipeCard from "./RecipeCard";

const RecipeGrid = ({ recipes }) => (
  <Box sx={{ mt: 4, px: { xs: 0.5, md: 1 } }}>
    <Box sx={{ textAlign: "center", mb: 4 }}>
      <Typography
        variant="h4"
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 1,
          color: "text.primary",
        }}
      >
        <AutoAwesomeRoundedIcon sx={{ color: "#f59e0b" }} />
        Fresh From The Pot
      </Typography>
      <Typography sx={{ mt: 1, color: "text.secondary" }}>
        {recipes.length} tasty recipe{recipes.length === 1 ? "" : "s"} ready to explore
      </Typography>
    </Box>

    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
        gap: 3,
        alignItems: "stretch",
      }}
    >
      {recipes.map((recipe, index) => (
        <RecipeCard key={index} recipe={recipe} />
      ))}
    </Box>
  </Box>
);

export default RecipeGrid;
